/* eslint-disable react-hooks/exhaustive-deps */
import { DependencyList, useMemo } from 'react';

export function useDebounceCallback<P extends string[]>(
  cb: (...args: P) => void,
  timeout: number,
  deps: DependencyList,
) {
  const cbMemoized = useMemo(() => {
    let timerId: ReturnType<typeof setTimeout> | null = null;
    let lastTimeCalled = 0;

    return (...args: P): void => {
      if (timerId) {
        clearTimeout(timerId);
      }
      const now = Date.now();
      const timeSinceLastCall = now - lastTimeCalled;
      lastTimeCalled = now;

      timerId = setTimeout(() => {
        cb(...args);
      }, Math.max(timeout - timeSinceLastCall, 0));
    };
  }, [cb, timeout, ...deps]);

  return cbMemoized;
}
